import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    layout: {},
  }),
  { index: 1 },
)

export { useStyles }
